import { api } from "@/utils/api";
export default class DmaRepository {
  async getDMAPolygonData(locationId: any){
    try {
      const response = await api.get(
        `dma/location/${locationId}`
      );
      return response.data;

    } catch (error) {
      console.error(error);
    }
  }

  async getDMADetailsData(
    dmaId: any,
    params?: { startDate?: string; endDate?: string },
  ){
    try {
      const queryParams = new URLSearchParams();
      if (params?.startDate) {
        queryParams.set('startDate', params.startDate);
      }
      if (params?.endDate) {
        queryParams.set('endDate', params.endDate);
      }
      const queryString = queryParams.toString();
      const response = await api.get(
        `dma/details/${dmaId}${queryString ? `?${queryString}` : ''}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getDMAMnfAnalysis(
    dmaId: any,
    params?: { startDate?: string; endDate?: string },
  ){
    try {
      const queryParams = new URLSearchParams();
      if (params?.startDate) {
        queryParams.set('startDate', params.startDate);
      }
      if (params?.endDate) {
        queryParams.set('endDate', params.endDate);
      }
      const queryString = queryParams.toString();
      const response = await api.get(
        `dma/${dmaId}/mnf-analysis${queryString ? `?${queryString}` : ''}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
